import { render, staticRenderFns } from "./UpdateGupshupChannel.vue?vue&type=template&id=b46bdb12&scoped=true"
import script from "./UpdateGupshupChannel.vue?vue&type=script&lang=js"
export * from "./UpdateGupshupChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateGupshupChannel.vue?vue&type=style&index=0&id=b46bdb12&prod&lang=scss&scoped=true"
import style1 from "./UpdateGupshupChannel.vue?vue&type=style&index=1&id=b46bdb12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46bdb12",
  null
  
)

export default component.exports